// Catálogo de móveis, por id. Cada lote fica no seu arquivo; este índice só junta.

import { EXTERIOR } from '../exterior.js';
import { SEASONAL_FURNITURE } from '../seasonal.js';
import type { FurnitureDef } from '../types.js';
import { COMMON_FURNITURE } from './common.js';
import { OFFICE_FURNITURE } from './office.js';
import { WALL_FURNITURE } from './wall.js';

export const FURNITURE: readonly FurnitureDef[] = [...OFFICE_FURNITURE, ...COMMON_FURNITURE, ...WALL_FURNITURE, ...EXTERIOR, ...SEASONAL_FURNITURE];

export const FURNITURE_BY_ID: ReadonlyMap<string, FurnitureDef> = new Map(FURNITURE.map((f) => [f.id, f]));
